exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles__select___1mPpW input{font-family:\"Open Sans\",sans-serif !important}.styles__shiftCursor___1b-NU input{padding-left:33px !important}", ""]);

// Exports
exports.locals = {
	"select": "styles__select___1mPpW",
	"shiftCursor": "styles__shiftCursor___1b-NU"
};